import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupUnion2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="boolean-group-union-2"><path d="M8.75 8.75H2.75V21.25H15.25V15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 15.25H21.25V2.75H8.75V8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.25 15.25H8.75V12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 8.75H15.25V11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBooleanGroupUnion2;
